import { Component, input, output } from '@angular/core';

/** Modal de aviso genérico: só a mensagem varia; fecha pelo X, por "Entendi!", pelo fundo ou ESC. */
@Component({
  selector: 'app-alert-modal',
  imports: [],
  templateUrl: './alert-modal.html',
  styleUrl: './alert-modal.scss',
  host: {
    '(document:keydown.escape)': 'close.emit()',
  },
})
export class AlertModal {
  readonly message = input.required<string>();

  readonly close = output<void>();
}
